import { styled, Box } from "@mui/material";

export const WrapperUIRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  width: "100%",
  backgroundColor: theme.palette.background?.default || "#f4f4f4",
}));

export const WrapperBody = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "block",
  padding: 0,
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
}));

export const PlayerArea = styled(Box, {
  shouldForwardProp: (prop) =>
    !["menuOpen", "animReady", "isMobile"].includes(prop),
})(({ theme, animReady, isMobile }) => ({
  position: "relative",
  minHeight: 0,
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "flex-start",
  boxSizing: "border-box",
  transition: animReady ? "all 0.5s ease-in-out" : "none",
}));

export const PlayerContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  flex: 1,
  minWidth: 0,
  height: "100%",
  minHeight: 0,
  backgroundColor: "#000",
  overflow: "hidden",
  transition: "all 0.5s ease-in-out",
}));

export const MenuContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    !["menuOpen", "animReady", "isMobile"].includes(prop),
})(({ theme, menuOpen, animReady, isMobile }) => ({
  flex: "0 0 auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "stretch",
  width: isMobile ? "100%" : "auto",
  height: isMobile ? "auto" : "100%",
  zIndex: 999,
  pointerEvents: menuOpen ? "auto" : "none",
  transition: animReady ? "all 0.5s ease-in-out" : "none",
  boxShadow: "0px -5px 10px rgba(0,0,0,0.25)",
}));

export const StreamSurface = styled(Box, {
  shouldForwardProp: (prop) => prop !== "ready",
})(({ theme, ready }) => ({
  flex: 1,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  position: "absolute",
  width: "100%",
  height: "100%",
  backgroundColor: "#000",
  opacity: ready ? 1 : 0,
  transition: "opacity 0.3s ease-in-out",
}));
